import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useExternalJobBoardsState() {
  return useAppState();
}

export function useExternalJobBoardsActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      pageNumber: null,
      numberOfPages: 1,
      externalJobBoards: [],
      filter: '',
      filterOptions: [],
      updateExternalJobBoardModalIsOpen: false,
      updateExternalJobBoard: {
        externalJobBoardId: '',
        url: '',
      },
      deleteExternalJobBoardModalIsOpen: false,
      deleteExternalJobBoard: {
        externalJobBoardId: '',
      },
      previewLinkDataModalIsOpen: false,
      previewLinkDataExternalJobBoard: null,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function openUpdateExternalJobBoardModal(externalJobBoard) {
    dispatch((appState) => ({
      ...appState,
      updateExternalJobBoardModalIsOpen: true,
      updateExternalJobBoard: {
        ...appState.updateExternalJobBoard,
        externalJobBoardId: externalJobBoard.id,
        url: externalJobBoard.url,
      },
    }));
  }

  function closeUpdateExternalJobBoardModal() {
    dispatch((appState) => ({
      ...appState,
      updateExternalJobBoardModalIsOpen: false,
      updateExternalJobBoard: {
        ...appState.updateExternalJobBoard,
        externalJobBoardId: '',
        url: '',
      },
    }));
  }

  function updateUpdateExternalJobBoardUrl(updateExternalJobBoardUrl) {
    dispatch((appState) => ({
      ...appState,
      updateExternalJobBoard: {
        ...appState.updateExternalJobBoard,
        url: updateExternalJobBoardUrl,
      },
    }));
  }

  function openDeleteExternalJobBoardModal(externalJobBoard) {
    dispatch((appState) => ({
      ...appState,
      deleteExternalJobBoardModalIsOpen: true,
      deleteExternalJobBoard: {
        ...appState.deleteExternalJobBoard,
        externalJobBoardId: externalJobBoard.id,
      },
    }));
  }

  function closeDeleteExternalJobBoardModal() {
    dispatch((appState) => ({
      ...appState,
      deleteExternalJobBoardModalIsOpen: false,
      deleteExternalJobBoard: {
        externalJobBoardId: '',
      },
    }));
  }

  function openPreviewLinkDataModal(externalJobBoard) {
    dispatch((appState) => ({
      ...appState,
      previewLinkDataModalIsOpen: true,
      previewLinkDataExternalJobBoard: externalJobBoard,
    }));
  }

  function closePreviewLinkDataModal() {
    dispatch((appState) => ({
      ...appState,
      previewLinkDataModalIsOpen: false,
      previewLinkDataExternalJobBoard: null,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    openUpdateExternalJobBoardModal,
    closeUpdateExternalJobBoardModal,
    updateUpdateExternalJobBoardUrl,
    openDeleteExternalJobBoardModal,
    closeDeleteExternalJobBoardModal,
    openPreviewLinkDataModal,
    closePreviewLinkDataModal,
    clearFeedback,
  };
}
